// @flow

import React from "react";

import { gettext, t } from "ttag";
import style from "./style.module.scss";

import { Row, Col } from "reactstrap";

type Props = {
    agency: {
        address: {
            city: string,
            postalCode: string,
            number: string,
            street: string,
            countryCode: string,
        },
        companyNumber: string,
        companyName: string,
        bivNumber: string,
        baNumber: string,
        bankAccount: string,
        facebookUrl: string,
        broker: boolean,
        syndic: boolean,
        management: boolean,
    },
    country: string,
};

const AgencyLegalInformation = ({
    agency: {
        address,
        companyNumber,
        bivNumber,
        baNumber,
        bankAccount,
        companyName,
        broker,
        syndic,
        management,
    },
    country,
}: Props) => {
    const agencyTypes = Object.entries({ broker, syndic, management })
        .filter(([key, value]) => {
            if (value) return key;
        })
        .map(([key]) => {
            return gettext(t`agency.information.details.${key}`);
        });

    return (
        <div className={style.agencyInformation} id="agency-information">
            <div className={style.title}>{t`agency.information.legal`}</div>
            <Row className={style.informationDetailsWrapper}>
                <Col lg={"6"}>
                    <div className={style.informationDetailsTitle}>
                        {agencyTypes.length > 0 &&
                            t`agency.information.details ${
                                agencyTypes.length === 1
                                    ? agencyTypes[0]
                                    : agencyTypes.join(", -")
                            }`}
                    </div>
                    <div>
                        {bankAccount && (
                            <div className={style.informationDetailsItem}>
                                <span
                                    className={
                                        style.informationDetailsItemLabel
                                    }
                                >{t`agency.information.details.bank-account`}</span>
                                <span>{bankAccount}</span>
                            </div>
                        )}
                        {address.countryCode === "BE" && (
                            <div className={style.informationDetailsItem}>
                                <span
                                    className={
                                        style.informationDetailsItemLabel
                                    }
                                >{t`agency.information.details.biv-number`}</span>
                                <span>{`${bivNumber} (${t`agency.information.details.biv-origin`})`}</span>
                            </div>
                        )}

                        <div className={style.informationDetailsItem}>
                            <span
                                className={style.informationDetailsItemLabel}
                            >{t`agency.information.details.company-number`}</span>
                            <span>{companyNumber}</span>
                        </div>
                        <div className={style.informationDetailsItem}>
                            <span
                                className={style.informationDetailsItemLabel}
                            >{t`agency.information.details.ba-number`}</span>
                            <span>{baNumber}</span>
                        </div>
                        {companyName && (
                            <div className={style.informationDetailsItem}>
                                <span
                                    className={
                                        style.informationDetailsItemLabel
                                    }
                                >{t`agency.information.details.company-name`}</span>
                                <span>{companyName}</span>
                            </div>
                        )}
                        {country.toUpperCase() === "LU" && (
                            <>
                                <div className={style.informationDetailsItem}>
                                    <span
                                        className={
                                            style.informationDetailsItemLabel
                                        }
                                    >{t`agency.information.details.authorization-number`}</span>
                                    <span>10131847/0</span>
                                </div>
                                <div className={style.informationDetailsItem}>
                                    <span
                                        className={
                                            style.informationDetailsItemLabel
                                        }
                                    >{t`agency.information.details.register-number`}</span>
                                    <span>B257240</span>
                                </div>
                            </>
                        )}
                    </div>
                </Col>
                {address.countryCode === "BE" && (
                    <Col
                        lg={"6"}
                        className={style.informationDetailsRightColumn}
                    >
                        <div
                            className={style.informationDetailsRightColumnItem}
                        >
                            <div
                                className={style.informationDetailsAddressTitle}
                            >{t`agency.information.details.ipi-address.title`}</div>
                            <div
                                className={
                                    style.informationDetailsAddressDescription
                                }
                            >{t`agency.information.details.ipi-address.description`}</div>
                        </div>
                        <div
                            className={style.informationDetailsRightColumnItem}
                        >
                            <div
                                className={style.informationDetailsWebsiteTitle}
                            >{t`agency.information.details.ipi-website.title`}</div>
                            <a
                                className={
                                    style.informationDetailsWebsiteDescription
                                }
                                href={t`agency.information.details.ipi-website.url`}
                            >{t`agency.information.details.ipi-website.description`}</a>
                        </div>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default AgencyLegalInformation;
